import React, { Fragment, useState, useEffect, useRef } from 'react';
import Grid from "../../../Grid";
import Button from "../../../Button";
import { Controller, useForm } from 'react-hook-form';
import DatePicker from "react-datepicker";
import styles from "./ShippingForm.module.sass";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import OrderPackage from '../../../../models/OrderPackage';
import { Cart, Order, Package } from '../../../../models';
import axios from 'axios';

function insertAddressDomNode(line1String, line2String, line3String, line4String) {
  const div = document.createElement('div')
  const p = document.createElement('p')
  const br1 = document.createElement('br')
  const br2 = document.createElement('br')
  const br3 = document.createElement('br')
  const br4 = document.createElement('br')
  const br5 = document.createElement('br')
  const br6 = document.createElement('br')

  div.id = 'shipping-address'
  div.style.display = 'none'

  p.classList.add('p2')

  p.appendChild(br1)
  p.appendChild(br2)
  p.appendChild(br3)

  const line1 = document.createTextNode(line1String)
  const line2 = document.createTextNode(line2String)
  const line3 = document.createTextNode(line3String)
  const line4 = document.createTextNode(line4String)

  p.appendChild(line1)
  p.appendChild(br4)

  p.appendChild(line2)
  p.appendChild(br5)

  if (line3.data !== '') {
    p.appendChild(line3)
    p.appendChild(br6)
  }

  p.appendChild(line4)

  div.appendChild(p)
  document.body.appendChild(div)
}

function printPackingSlip() {
  const newWindow = window.open('', 'PRINT', 'height=200,width=1000')
  newWindow.document.write('<html><head><title></title>')
  newWindow.document.write('</head><body >')
  newWindow.document.write('<h1>' + document.getElementById('shipping-address').innerHTML + '</h1>')
  newWindow.print()
}

const Form = ({ orderPackageId, isLink, closeModal, defaultValue }) => {
  const { register, handleSubmit, control, trigger, watch, setValue, unregister, formState: { errors } } = useForm();
  const watchItemNumber = watch("order_package_id");
  const watchShippingLocation = watch("shipping_location");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [orderPackage, setOrderPackage] = useState();
  // Which print action (if any) the clicked submit button requested. Set in the
  // button's onClick (fires before submit), read once in onSubmit.
  const printActionRef = useRef(null);
  const isWorkOrder = (watchItemNumber || '').toString().startsWith('WO-');

  useEffect(() => {
    // Set default value for item number if provided
    if (defaultValue) {
      setValue('order_package_id', defaultValue);
    }

    if (!orderPackageId) return;

    OrderPackage
      .find(orderPackageId)
      .then((response) => {
        setOrderPackage(response.data)
      });

    setValue('order_package_id', orderPackageId);
  }, [orderPackageId, defaultValue]);

  useEffect(() => {
    if (!watchItemNumber) return;

    OrderPackage
      .includes(['package', { cart: 'orders' }])
      .find(watchItemNumber)
      .then((res) => {
        if (res.data.package.season.includes('senior')) {
          const order = res.data.cart.orders[0]

          insertAddressDomNode(
            `${order.firstName} ${order.lastName}`,
            order.shippingAddress,
            order.shippingAddress2 || '',
            `${order.shippingCity}, ${order.shippingState} ${order.shippingZip}`,
          )
        }
        setOrderPackage(res.data)
      })
      .catch((err) => console.log(err))

  }, [watchItemNumber])

  // Open the relevant work-order document in a new window; it auto-prints on load.
  const triggerPrint = (itemNumber, printAction) => {
    if (!printAction || !itemNumber.startsWith('WO-')) return;
    const woId = itemNumber.replace('WO-', '');
    const url = printAction === 'label'
      ? `/admin/work_orders/${woId}/packing_slip?label=1`
      : `/admin/work_orders/${woId}/packing_slip`;
    window.open(url, '_blank');
  }

  const onSubmit = (data) => {
    const printAction = printActionRef.current;
    printActionRef.current = null;
    const itemNumber = data.order_package_id;
    const date  = new Date();

    // Determine the ID format for the API:
    // - IDs with dashes (WO-xxx, ORDER-xxx, ITEM-xxx) are sent as-is
    // - Numeric IDs are Order IDs (printed on yearbook barcodes)
    const itemId = data.order_package_id.includes('-')
      ? data.order_package_id
      : `ORDER-${data.order_package_id}`;

    axios
      .post(`/api/v1/orders/mark_as_shipped`,
        { item:
            { shipper_initials: data.shipper_initials,
              ship_destination: data.shipping_location,
              ship_date: data.shipping_date || date.toLocaleDateString("en-US"),
              id: itemId,
              category: data.scan_category || 'photo',
              ups_tracking_number: data.ups_tracking_number || null,
              notes: data.notes || null
            }
        })
      .then(() => {
        sendToastMessage(itemNumber);
        triggerPrint(itemNumber, printAction);
      })
      .catch((error) => {
        sendFailToastMessage(error, itemNumber)
      })
      .finally(() => {
        setValue('order_package_id', '');
      });
  }

  const sendToastMessage = (item_id) => {
    toast.success(`Item #${item_id} successfully marked as shipped`, {
      position: "bottom-left",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  const sendFailToastMessage = (error, item_id) => {
    const message = error && error.response && error.response.data.errors || `Item #${item_id} was not marked as shipped. Please try again or check the item number`
    toast.error(message , {
      position: "bottom-left",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  return (
    <Fragment>
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        <Grid container justify='center' spacing={2}>
          <Grid item xs={3} md={3}>
            <label className={styles.label}>Initials</label>
            <input
              className={styles.input}
              {...register("shipper_initials", { required: true })}
            />
          </Grid>

          <Grid item xs={3} md={3}>
            <label className={styles.label}>Date</label>
            <Controller
              control={control}
              name="shipping_date"
              render={({ field }) => (
                <DatePicker selected={field.value || Date.now()}
                            showTimeSelect
                            onChange={(date) => field.onChange(date)}
                            className={styles.input} />
              )}
            />
          </Grid>

          <Grid item xs={3} md={3}>
            <label className={styles.label}>Action</label>
            <select {...register("shipping_location")} className={`${styles.input} ${styles.select}`}>
              <option value="completed">Completed</option>
              <option value="ship_to_mail">Mailed</option>
              <option value="ship_to_school">Ship to school</option>
              <option value="ship_ups">UPS</option>
            </select>
          </Grid>

          <Grid item xs={3} md={3}>
            <label className={styles.label}>Type</label>
            <select {...register("scan_category")} className={`${styles.input} ${styles.select}`} defaultValue="photo">
              <option value="photo">Photo Order</option>
              <option value="yearbook">Yearbook</option>
            </select>
          </Grid>
        </Grid>

        {watchShippingLocation === 'ship_ups' && (
          <div style={{ marginBottom: '10px' }}>
            <label className={styles.label}>UPS Tracking Number</label>
            <input
              className={styles.input}
              {...register("ups_tracking_number")}
              placeholder="Enter UPS tracking number"
            />
          </div>
        )}

        <label className={styles.label}>Item Number</label>
        <input
          className={styles.input}
          {...register("order_package_id", { required: true })}
        />

        <label className={styles.label}>Notes</label>
        <input
          className={styles.input}
          {...register("notes")}
          style={{ width: '100%' }}
        />

        {/* All actions share one row so the modal height matches the original
            single-Submit layout (no overflow past the modal's 80vh body). */}
        <div style={{ display: 'flex', gap: '8px' }}>
          <Button
            classes={styles.submit}
            variant='submit'
            type='submit'
            style={{ flex: 1 }}
            disabled={!watchItemNumber || isSubmitting}
            onClick={() => { printActionRef.current = null; }}
          >
            Submit
          </Button>
          {isWorkOrder && (
            <>
              <Button
                classes={styles.submit}
                variant='submit'
                type='submit'
                style={{ flex: 1 }}
                disabled={!watchItemNumber || isSubmitting}
                onClick={() => { printActionRef.current = 'wo'; }}
              >
                Submit/Print WO
              </Button>
              <Button
                classes={styles.submit}
                variant='submit'
                type='submit'
                style={{ flex: 1 }}
                disabled={!watchItemNumber || isSubmitting}
                onClick={() => { printActionRef.current = 'label'; }}
              >
                Submit/Print Label
              </Button>
            </>
          )}
        </div>
      </form>
    </Fragment>
  )
}

export default Form;
